export type SimpleRecipe = {
  id: number;
  image: string;
  style: string;
  salon: string;
  stylist: string;
  color: string;
};

export const simpleRecipeList: SimpleRecipe[] = [
  { id: 1, image: "image", style: "style", salon: "salon", stylist: "stylist", color: "color" },
  { id: 2, image: "image", style: "style", salon: "salon", stylist: "stylist", color: "color" },
  { id: 3, image: "image", style: "style", salon: "salon", stylist: "stylist", color: "color" },
];